import * as React from "react";
import { Typography, makeStyles } from "@material-ui/core";
import { TextEditor } from "src/common/components";

const useStyles = makeStyles({
  companyValueText: {
    color: "#4d4d4e",
    fontSize: "1.4rem",
    margin: "0 0 8px"
  },
  editorContainer: {
    background: "#ffffff",
    border: "1px solid #e6e6e6",
    borderRadius: 4,
    boxShadow: "0 2px 4px 0 rgba(219, 219, 219, 0.5)",
    margin: "0px 0px 24px",
    padding: "0px"
  },
  questionTitle: {
    fontSize: "2rem",
    fontWeight: 600,
    lineHeight: "27px",
    margin: "0 0 8px"
  },
  required: {
    "&:after": {
      color: "rgba(84, 84, 84, 0.52)",
      content: '"*"',
      position: "absolute" as "absolute"
    }
  }
});

interface IProps {
  readOnly: boolean;
  name: string;
  setFieldValue: (name: string, value: string | null) => void;
  value: string;
  title?: string;
  placeholder: string;
  disabled: boolean;
}

const SupervisorComment = ({ readOnly, name, disabled, setFieldValue, value, title = "", placeholder }: IProps) => {
  const classes = useStyles();
  const handleChange = React.useCallback(
    (newValue: string) => {
      setFieldValue(name, newValue);
    },
    [setFieldValue, name]
  );

  return (
    <div>
      <Typography className={classes.questionTitle}>
        <span>{title}</span>
      </Typography>
      <div className={classes.editorContainer}>
        <TextEditor
          placeholder={placeholder}
          readOnly={readOnly}
          disabled={disabled}
          defaultValue={value}
          onChange={handleChange}
          enableGrow
          enableHeadings
        />
      </div>
    </div>
  );
};

export default React.memo(SupervisorComment);
